import React from 'react';
import Moment from 'react-moment';
import clsx from 'clsx';
import { IconeStatusPedido } from '../../presentations';
import {
    makeStyles,
    Typography,
    Paper,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider
} from '@material-ui/core';
import { InfoOutlined as InfoIcon } from '@material-ui/icons';
import { StatusPedidoEnum } from '../../enums';

const tamanhoIcone = 40;

const useStyles = makeStyles(theme => ({
    paper: {
        padding: 10
    },
    container1: {
        display: 'flex',
        alignItems: 'center'
    },
    divTitulo: {
        flex: 1,
        marginLeft: 10
    },
    container2: {
        display: 'flex'
    },
    divDivider: {
        flexBasis: tamanhoIcone,
        minHeight: 50
    },
    divData: {
        flex: 1,
        marginLeft: 10
    },
    divIcon: {
        backgroundColor: theme.palette.action.selected,
        color: theme.palette.background.paper,
        width: tamanhoIcone,
        height: tamanhoIcone,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    titulo: {
        color: theme.palette.primary.main
    },
    data: {
        color: theme.palette.text.disabled
    },
    completed: {
        backgroundColor: theme.palette.secondary.main
    },
    gutters: {
        padding: 0
    },
    list: {
        padding: 0
    },
    listItem: {
        alignItems: 'normal'
    },
    listItemText: {
        margin: 0
    },
    listItemIcon: {
        minWidth: 0
    },
    iconButton: {
        padding: 0
    },
    disabled: {
        color: theme.palette.text.secondary
    }
}));

function StepperVerticalDetalhamentoPedido(
    {
        lista,
        handleClickOpenInfo
    }
) {
    const classes = useStyles();
    const activeStep = lista.map(item => item.statusHabilitado).lastIndexOf(true);

    return (
        <Paper elevation={0}
            className={classes.paper}>
            {
                lista.map((item, index) => (
                    <div key={index}>
                        <div className={classes.container1}>
                            <div>
                                <div className={clsx(classes.divIcon, { [classes.completed]: index <= activeStep })}>
                                    <IconeStatusPedido codigoStatus={item.codigoStatus} />
                                </div>
                            </div>
                            <div className={classes.divTitulo}>
                                <List className={classes.list}>
                                    <ListItem classes={{
                                        root: classes.listItem,
                                        gutters: classes.gutters
                                    }}>
                                        <ListItemText className={classes.listItemText}>
                                            <Typography variant='h5'
                                                className={clsx({
                                                    [classes.titulo]: index <= activeStep,
                                                    [classes.disabled]: index > activeStep
                                                })}>
                                                {StatusPedidoEnum.properties[item.codigoStatus].status}
                                            </Typography>
                                        </ListItemText>
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <IconButton classes={{ root: classes.iconButton }}
                                                onClick={() => handleClickOpenInfo(item.codigoStatus)}>
                                                <InfoIcon />
                                            </IconButton>
                                        </ListItemIcon>
                                    </ListItem>
                                </List>
                            </div>
                        </div>
                        <div className={classes.container2}>
                            <div className={classes.divDivider}>
                                {
                                    (() => {
                                        if (index <= lista.length - 2) {
                                            return <Divider orientation='vertical'
                                                className={clsx({ [classes.completed]: index + 1 <= activeStep })}
                                                style={{ margin: 'auto', width: 3 }} />
                                        }
                                    })()
                                }
                            </div>
                            <div className={classes.divData}>
                                <Typography variant='caption'
                                    className={clsx({
                                        [classes.data]: index <= activeStep,
                                        [classes.disabled]: index > activeStep
                                    })}>
                                    {item.dataOcorrencia && <Moment utc='0' format="DD/MM/YYYY">{item.dataOcorrencia}</Moment>}
                                </Typography>
                            </div>
                        </div>
                    </div>
                ))
            }
        </Paper>
    );
}

export default StepperVerticalDetalhamentoPedido;